<template>
  <div id="join">
    <div class="header">
      <a href="https://www.iberbox.com"><img src="/img/icons/icono_blanco_sin_texto.png" alt="IBERBOX"></a>
      <p class="logo">IBERBOX</p>
    </div>
    <div class="contenedor-body">
      <div class="contenedor-publicidad">
        <h2 class="title">{{ $t('join.secureCloud') }}</h2>
        <div class="lista">
          <div class="linea">
            <img src="/img/icons/check.svg">
            <p class="text">{{ $t('download.endToEndEncryption') }}</p>
          </div>
          <div class="linea">
            <img src="/img/icons/check.svg">
            <p class="text">{{ $t('sidebar.backups') }}</p>
          </div>
          <div class="linea">
            <img src="/img/icons/check.svg">
            <p class="text">{{ $t('sidebar.register') }}</p>
          </div>
          <div class="linea">
            <img src="/img/icons/check.svg">
            <p class="text">{{ $t('download.secureCloud') }}</p>
          </div>
          <div class="linea">
            <img src="/img/icons/check.svg">
            <p class="text">{{ $t('download.transparentIntegration') }}</p>
          </div>
        </div>
        <div class="buttons">
          <router-link to="/login" class="button-access" :title="$t('buttons.access')" :aria-label="$t('buttons.access')">
            <span>{{ $t('buttons.access') }}</span>
          </router-link>
          <router-link to="/register" class="button-registry" :title="$t('buttons.registry')" :aria-label="$t('buttons.registry')">
            <span>{{ $t('buttons.registry') }}</span>
          </router-link>
        </div>
      </div>
      <div class="contenedor-login">
        <img src="/img/icons/JoinPage/at-sign-icon.svg">
        <h1>{{ $t('join.verifyAccess') }}</h1>
        <p>{{ $t('join.emailRequired') }}</p>
        <div class="contenedor-enlaces">
          <input class="input input--block" type="email" v-model="emailLink" :placeholder="$t('dealers.email')" :disabled="displayEmail">
          <button class="button button-create" :title="$t('login.verify')" @click="verificarEmail" :disabled="emailLink === ''">
            <span>{{ $t('login.verify') }}</span>
          </button>
        </div>
        <div class="mensaje-error" v-if="message !== ''" :style="messageStyle">
          <img v-if="isError" src="/img/icons/JoinPage/wrong-icon.svg">
          <img v-else src="/img/icons/JoinPage/check-icon.svg">
          <p>{{ this.message }}</p>
        </div>
        <div v-if="isSession" class="cambiar-cuenta">
          <img src="/img/icons/JoinPage/alert-icon.svg">
          <p>{{ $t('join.logOutCurrentSession') }}</p>
          <p class="underline" @click="changeEmail">{{ $t('join.useAnotherEmail') }}</p>
        </div>
        <button class="button button-continue" :title="$t('pricing.continue')" @click="clickContinue" :disabled="hasAccount === ''">
          <span>{{ $t('pricing.continue') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import i18n from '@/i18n';
import { mapMutations } from 'vuex';
import { files as ibbapi } from '@/api';
import * as auth from '@/utils/auth';

export default {
  name: 'join',
  data: function () {
    return {
      emailLink: '',
      link: '',
      message: '',
      isError: false,
      hasAccount: '',
      accountHandle: '',
      accountKey: '',
      registrationId: '',
      isSession: false,
      displayEmail: false
    };
  },
  watch: {
    emailLink() {
      this.hasAccount = '';
    }
  },
  computed: {
    messageStyle() {
      let border;
      let background;

      if (this.isError) {
        background = '#ff2e2e';
        border = '2px solid #b52222';
      } else {
        background = '#4ccca0';
        border = '2px solid #349e7a';
      }

      return {backgroundColor: background, border: border};
    },
  },
  async mounted () {
    this.link = window.location.href;
    try {
      let action = await ibbapi.getUserInfo();
      this.emailLink = action.userInfo.email;
      this.isSession = true;
      this.displayEmail = true;
    } catch (e) {
      this.isSession = false;
    }
  },
  methods: {
    ...mapMutations([ 'setAccountHandleJoin', 'setAccountKeyJoin', 'setRegistrationId' ]),
    async verificarEmail() {
      let action = await ibb.checkJoinLink(this.link, this.emailLink);
      if (action.error.type === 1 || action.error.type === 4) {
        this.isError = true;
        this.message = i18n.t('join.emailError');
      } else if (!action.error.type && action.text === undefined) {  
        this.accountHandle = action.accountHandle;
        this.accountKey = action.session;
        this.hasAccount = true;
        this.isError = false;
        this.message = i18n.t('join.emailVerifiedAccount');
      } else if (!action.error.type && action.text !== undefined) {  
        this.accountHandle = action.accountHandle;
        this.accountKey = action.session;
        this.registrationId = action.text;
        this.hasAccount = false;
        this.isError = false;
        this.message = i18n.t('join.emailVerifiedNoAccount');
      }
    },
    async clickContinue() {
      this.setAccountHandleJoin(this.accountHandle);
      this.setAccountKeyJoin(this.accountKey);
      if (this.hasAccount) {
        if (this.isSession) {
          try {
            await auth.joinAccountWithCurrentUser(this.accountHandle, this.accountKey);
            this.$showSuccess(this.$t('settings.joinAccountSuccessfully'));
          } catch (e) {
            this.$showError(e);
          }
          try {
            await auth.validateLogin();
            this.$router.push({ path: '/profile/settings' });
            window.history.go('/cloud');
          } catch (e) {
            this.$showError(e);
          }
        } else {
          this.$router.push({ path: '/login' });
        }
      } else {
        this.setRegistrationId(this.registrationId);
        this.$router.push({ path: '/register', query: {email: Base64.encodeURI(this.emailLink)} });
      }
    },
    async changeEmail() {
      this.isSession = false;
      this.displayEmail = false;
      await auth.logoutJoin();
    }
  }
};
</script>